export const PHONE_PREFIX_DEFAULT = "+352";

export const PHONE_PREFIX_LIST = [
  // Priority countries: LU, FR, DE, BE, PT
  {
    "prefix": "352",
    "isoCode": "LU",
    "term": "Luxembourg",
  },
  {
    "prefix": "33",
    "isoCode": "FR",
    "term": "France",
  },
  {
    "prefix": "49",
    "isoCode": "DE",
    "term": "Allemagne",
  },
  {
    "prefix": "32",
    "isoCode": "BE",
    "term": "Belgique",
  },
  {
    "prefix": "351",
    "isoCode": "PT",
    "term": "Portugal",
  },
  // Other countries alphabetically
  {
    "prefix": "27",
    "isoCode": "ZA",
    "term": "Afrique du Sud",
  },
  {
    "prefix": "213",
    "isoCode": "DZ",
    "term": "Algérie",
  },
  {
    "prefix": "966",
    "isoCode": "SA",
    "term": "Arabie saoudite",
  },
  {
    "prefix": "54",
    "isoCode": "AR",
    "term": "Argentine",
  },
  {
    "prefix": "61",
    "isoCode": "AU",
    "term": "Australie",
  },
  {
    "prefix": "43",
    "isoCode": "AT",
    "term": "Autriche",
  },
  {
    "prefix": "55",
    "isoCode": "BR",
    "term": "Brésil",
  },
  {
    "prefix": "359",
    "isoCode": "BG",
    "term": "Bulgarie",
  },
  {
    "prefix": "1",
    "isoCode": "CA",
    "term": "Canada",
  },
  {
    "prefix": "86",
    "isoCode": "CN",
    "term": "Chine",
  },
  {
    "prefix": "82",
    "isoCode": "KR",
    "term": "Corée du Sud",
  },
  {
    "prefix": "385",
    "isoCode": "HR",
    "term": "Croatie",
  },
  {
    "prefix": "45",
    "isoCode": "DK",
    "term": "Danemark",
  },
  {
    "prefix": "20",
    "isoCode": "EG",
    "term": "Égypte",
  },
  {
    "prefix": "971",
    "isoCode": "AE",
    "term": "Émirats arabes unis",
  },
  {
    "prefix": "34",
    "isoCode": "ES",
    "term": "Espagne",
  },
  {
    "prefix": "372",
    "isoCode": "EE",
    "term": "Estonie",
  },
  {
    "prefix": "1",
    "isoCode": "US",
    "term": "États-Unis",
  },
  {
    "prefix": "358",
    "isoCode": "FI",
    "term": "Finlande",
  },
  {
    "prefix": "30",
    "isoCode": "GR",
    "term": "Grèce",
  },
  {
    "prefix": "36",
    "isoCode": "HU",
    "term": "Hongrie",
  },
  {
    "prefix": "91",
    "isoCode": "IN",
    "term": "Inde",
  },
  {
    "prefix": "62",
    "isoCode": "ID",
    "term": "Indonésie",
  },
  {
    "prefix": "353",
    "isoCode": "IE",
    "term": "Irlande",
  },
  {
    "prefix": "972",
    "isoCode": "IL",
    "term": "Israël",
  },
  {
    "prefix": "39",
    "isoCode": "IT",
    "term": "Italie",
  },
  {
    "prefix": "81",
    "isoCode": "JP",
    "term": "Japon",
  },
  {
    "prefix": "254",
    "isoCode": "KE",
    "term": "Kenya",
  },
  {
    "prefix": "371",
    "isoCode": "LV",
    "term": "Lettonie",
  },
  {
    "prefix": "370",
    "isoCode": "LT",
    "term": "Lituanie",
  },
  {
    "prefix": "60",
    "isoCode": "MY",
    "term": "Malaisie",
  },
  {
    "prefix": "212",
    "isoCode": "MA",
    "term": "Maroc",
  },
  {
    "prefix": "52",
    "isoCode": "MX",
    "term": "Mexique",
  },
  {
    "prefix": "234",
    "isoCode": "NG",
    "term": "Nigéria",
  },
  {
    "prefix": "47",
    "isoCode": "NO",
    "term": "Norvège",
  },
  {
    "prefix": "64",
    "isoCode": "NZ",
    "term": "Nouvelle-Zélande",
  },
  {
    "prefix": "31",
    "isoCode": "NL",
    "term": "Pays-Bas",
  },
  {
    "prefix": "63",
    "isoCode": "PH",
    "term": "Philippines",
  },
  {
    "prefix": "48",
    "isoCode": "PL",
    "term": "Pologne",
  },
  {
    "prefix": "420",
    "isoCode": "CZ",
    "term": "République tchèque",
  },
  {
    "prefix": "40",
    "isoCode": "RO",
    "term": "Roumanie",
  },
  {
    "prefix": "44",
    "isoCode": "GB",
    "term": "Royaume-Uni",
  },
  {
    "prefix": "7",
    "isoCode": "RU",
    "term": "Russie",
  },
  {
    "prefix": "65",
    "isoCode": "SG",
    "term": "Singapour",
  },
  {
    "prefix": "421",
    "isoCode": "SK",
    "term": "Slovaquie",
  },
  {
    "prefix": "386",
    "isoCode": "SI",
    "term": "Slovénie",
  },
  {
    "prefix": "46",
    "isoCode": "SE",
    "term": "Suède",
  },
  {
    "prefix": "41",
    "isoCode": "CH",
    "term": "Suisse",
  },
  {
    "prefix": "66",
    "isoCode": "TH",
    "term": "Thaïlande",
  },
  {
    "prefix": "216",
    "isoCode": "TN",
    "term": "Tunisie",
  },
  {
    "prefix": "90",
    "isoCode": "TR",
    "term": "Turquie",
  },
  {
    "prefix": "380",
    "isoCode": "UA",
    "term": "Ukraine",
  },
  {
    "prefix": "84",
    "isoCode": "VN",
    "term": "Viêt Nam",
  },
]

export const COUNTRY_LIST = [
  // Priority countries: LU, FR, DE, BE
  {
    "isoCode": "LU",
    "term": "Luxembourg",
  },
  {
    "isoCode": "FR",
    "term": "France",
  },
  {
    "isoCode": "DE",
    "term": "Allemagne",
  },
  {
    "isoCode": "BE",
    "term": "Belgique",
  },
  // Other countries alphabetically
  {
    "isoCode": "ZA",
    "term": "Afrique du Sud",
  },
  {
    "isoCode": "SA",
    "term": "Arabie saoudite",
  },
  {
    "isoCode": "AR",
    "term": "Argentine",
  },
  {
    "isoCode": "AU",
    "term": "Australie",
  },
  {
    "isoCode": "AT",
    "term": "Autriche",
  },
  {
    "isoCode": "BR",
    "term": "Brésil",
  },
  {
    "isoCode": "CA",
    "term": "Canada",
  },
  {
    "isoCode": "CN",
    "term": "Chine",
  },
  {
    "isoCode": "KR",
    "term": "Corée du Sud",
  },
  {
    "isoCode": "DK",
    "term": "Danemark",
  },
  {
    "isoCode": "EG",
    "term": "Égypte",
  },
  {
    "isoCode": "AE",
    "term": "Émirats arabes unis",
  },
  {
    "isoCode": "ES",
    "term": "Espagne",
  },
  {
    "isoCode": "US",
    "term": "États-Unis",
  },
  {
    "isoCode": "FI",
    "term": "Finlande",
  },
  {
    "isoCode": "GR",
    "term": "Grèce",
  },
  {
    "isoCode": "HU",
    "term": "Hongrie",
  },
  {
    "isoCode": "IN",
    "term": "Inde",
  },
  {
    "isoCode": "ID",
    "term": "Indonésie",
  },
  {
    "isoCode": "IE",
    "term": "Irlande",
  },
  {
    "isoCode": "IL",
    "term": "Israël",
  },
  {
    "isoCode": "IT",
    "term": "Italie",
  },
  {
    "isoCode": "JP",
    "term": "Japon",
  },
  {
    "isoCode": "MY",
    "term": "Malaisie",
  },
  {
    "isoCode": "MX",
    "term": "Mexique",
  },
  {
    "isoCode": "NO",
    "term": "Norvège",
  },
  {
    "isoCode": "NZ",
    "term": "Nouvelle-Zélande",
  },
  {
    "isoCode": "NL",
    "term": "Pays-Bas",
  },
  {
    "isoCode": "PH",
    "term": "Philippines",
  },
  {
    "isoCode": "PL",
    "term": "Pologne",
  },
  {
    "isoCode": "PT",
    "term": "Portugal",
  },
  {
    "isoCode": "CZ",
    "term": "République tchèque",
  },
  {
    "isoCode": "RO",
    "term": "Roumanie",
  },
  {
    "isoCode": "GB",
    "term": "Royaume-Uni",
  },
  {
    "isoCode": "RU",
    "term": "Russie",
  },
  {
    "isoCode": "SG",
    "term": "Singapour",
  },
  {
    "isoCode": "SE",
    "term": "Suède",
  },
  {
    "isoCode": "CH",
    "term": "Suisse",
  },
  {
    "isoCode": "TH",
    "term": "Thaïlande",
  },
  {
    "isoCode": "TR",
    "term": "Turquie",
  },
  {
    "isoCode": "VN",
    "term": "Viêt Nam",
  },
]

export const LANGUAGE_LIST = [
  // Priority languages: LU, FR, DE, EN, PT
  {
    "languageIso": "lu",
    "term": "Luxembourgeois",
  },
  {
    "languageIso": "fr",
    "term": "Français",
  },
  {
    "languageIso": "de",
    "term": "Allemand",
  },
  {
    "languageIso": "en",
    "term": "Anglais",
  },
  {
    "languageIso": "pt",
    "term": "Portugais",
  },
  // Other languages alphabetically
  {
    "languageIso": "ar",
    "term": "Arabe",
  },
  {
    "languageIso": "zh",
    "term": "Chinois",
  },
  {
    "languageIso": "ko",
    "term": "Coréen",
  },
  {
    "languageIso": "da",
    "term": "Danois",
  },
  {
    "languageIso": "es",
    "term": "Espagnol",
  },
  {
    "languageIso": "fi",
    "term": "Finnois",
  },
  {
    "languageIso": "el",
    "term": "Grec",
  },
  {
    "languageIso": "hi",
    "term": "Hindi",
  },
  {
    "languageIso": "hu",
    "term": "Hongrois",
  },
  {
    "languageIso": "it",
    "term": "Italien",
  },
  {
    "languageIso": "ja",
    "term": "Japonais",
  },
  {
    "languageIso": "nl",
    "term": "Néerlandais",
  },
  {
    "languageIso": "no",
    "term": "Norvégien",
  },
  {
    "languageIso": "pl",
    "term": "Polonais",
  },
  {
    "languageIso": "ro",
    "term": "Roumain",
  },
  {
    "languageIso": "ru",
    "term": "Russe",
  },
  {
    "languageIso": "sv",
    "term": "Suédois",
  },
  {
    "languageIso": "cs",
    "term": "Tchèque",
  },
  {
    "languageIso": "tr",
    "term": "Turc",
  },
]

export function getFlagEmojiForPrefix(phonePrefix) {
  const matchingCountries = PHONE_PREFIX_LIST.filter(country => country.prefix === phonePrefix)
  const country = matchingCountries[0]
  if (!country) return phonePrefix
  return getFlagEmojiForCountry(country.isoCode)
}

export function getFlagEmojiForCountry(countryCode) {
  if (!countryCode) return;
  if (countryCode.toUpperCase() === 'EN') countryCode = "GB";
  
  const codePoints = countryCode
    .toUpperCase()
    .split('')
    .map(char => 127397 + char.charCodeAt())
  return String.fromCodePoint(...codePoints)
}
